const STATUS_PENDING = 1;
const STATUS_APPROVED = 2;
const STATUS_REJECTED = 3;

export default {
  pending: STATUS_PENDING,
  approved: STATUS_APPROVED,
  rejected: STATUS_REJECTED,
  toString(status) {
    return {
      [STATUS_PENDING]: 'Oczekuje na akceptację',
      [STATUS_APPROVED]: 'Zaakceptowano',
      [STATUS_REJECTED]: 'Odrzucono',
    }[status] || '-';
  },
};
